;(function () {
  'use strict'

  angular
    .module('contrast.tags')
    .factory('TagFactory', ['$http', 'UserService', TagFactory])

  function TagFactory($http, UserService) {
    return {
      tagServers: function (serverTags) {
        return $http.put(UserService.buildAPIUrl('/tags/servers'), serverTags)
      },
      tagServersBulk: function (serverTags) {
        return $http.put(
          UserService.buildAPIUrl('/tags/servers/bulk'),
          serverTags
        )
      },
      getServersTagsBulk: function (serversId) {
        return $http.post(UserService.buildAPIUrl('/tags/servers/bulk'), {
          servers_id: serversId
        })
      },
      getServersTags: function () {
        return $http.get(UserService.buildAPIUrl('/tags/servers/list'))
      },
      getServerTags: function (serverId) {
        return $http.get(
          UserService.buildAPIUrl('/tags/server/list/' + serverId)
        )
      },
      deleteServerTags: function (serverId, tag) {
        var form = { tag: tag }
        return $http['delete'](
          UserService.buildAPIUrl('/tags/server/' + serverId),
          {
            data: form,
            headers: { 'Content-Type': 'application/json' }
          }
        )
      },
      tagApplications: function (applicationTags) {
        return $http.put(
          UserService.buildAPIUrl('/tags/applications'),
          applicationTags
        )
      },
      tagApplicationsBulk: function (applicationsTags) {
        return $http.put(
          UserService.buildAPIUrl('/tags/applications/bulk'),
          applicationsTags
        )
      },
      getApplicationsTagsBulk: function (applicationsId) {
        return $http.get(UserService.buildAPIUrl('/tags/applications/bulk'), {
          params: {
            applicationsId: applicationsId
          }
        })
      },
      getApplicationsTags: function () {
        return $http.get(UserService.buildAPIUrl('/tags/applications/list'))
      },
      getApplicationTags: function (applicationId) {
        return $http.get(
          UserService.buildAPIUrl('/tags/application/list/' + applicationId)
        )
      },
      deleteApplicationTags: function (applicationId, tag) {
        var form = { tag: tag }
        return $http['delete'](
          UserService.buildAPIUrl('/tags/application/' + applicationId),
          {
            data: form,
            headers: { 'Content-Type': 'application/json' }
          }
        )
      },

      tagTraces: function (tracetags) {
        return $http.put(UserService.buildAPIUrl('/tags/traces'), tracetags)
      },
      deleteTraceTags: function (traceUuid, tag) {
        var form = { tag: tag }
        return $http['delete'](
          UserService.buildAPIUrl('/tags/trace/' + traceUuid),
          {
            data: form,
            headers: { 'Content-Type': 'application/json' }
          }
        )
      },
      tagTracesBulk: function (traceTags) {
        return $http.put(
          UserService.buildAPIUrl('/tags/traces/bulk'),
          traceTags
        )
      },
      getTracesTagsBulk: function (tracesUuid) {
        return $http.post(UserService.buildAPIUrl('/tags/traces/bulk'), {
          traces_uuid: tracesUuid
        })
      },
      getTraceTagsByTrace: function (traceUuid) {
        return $http.get(
          UserService.buildAPIUrl('/tags/traces/trace/' + traceUuid)
        )
      },
      getTraceTagsByOrganization: function () {
        return $http.get(UserService.buildAPIUrl('/tags/traces'))
      },
      getTraceTagsByApplication: function (applicationId, tagType) {
        return $http.get(
          UserService.buildAPIUrl('/tags/traces/application/' + applicationId),
          {
            params: {
              tagType: tagType
            }
          }
        )
      },
      getTraceTagsByServer: function (serverId) {
        return $http.get(
          UserService.buildAPIUrl('/tags/traces/server/' + serverId)
        )
      },
      addLibrariesTags: function (librariesTags) {
        return $http.post(
          UserService.buildAPIUrl('/tags/libraries'),
          librariesTags
        )
      },
      removeLibrariesTags: function (librariesTags) {
        return $http.delete(UserService.buildAPIUrl('/tags/libraries'), {
          data: librariesTags,
          headers: { 'Content-Type': 'application/json' }
        })
      },
      getLibrariesTags: function (data) {
        return $http.get(UserService.buildAPIUrl('/tags/libraries'), {
          params: data
        })
      },
      getAvailableTagsForLibraries: function () {
        return $http.get(UserService.buildAPIUrl('/tags/libraries/list'))
      },
      deleteLibraryTags: function (libraryHash, tag) {
        var form = { tag: tag }
        return $http['delete'](
          UserService.buildAPIUrl('/tags/library/' + libraryHash),
          {
            data: form,
            headers: { 'Content-Type': 'application/json' }
          }
        )
      },
      tagAttacks: function (attackTags) {
        return $http.put(UserService.buildAPIUrl('/tags/attacks'), attackTags)
      },
      tagAttacksBulk: function (attackTags) {
        return $http.put(
          UserService.buildAPIUrl('/tags/attacks/bulk'),
          attackTags
        )
      },
      getAttacksTagsBulk: function (attacksId) {
        return $http.post(UserService.buildAPIUrl('/tags/attacks/bulk'), {
          attacks_id: attacksId
        })
      },
      getAttacksTags: function () {
        return $http.get(UserService.buildAPIUrl('/tags/attacks/list'))
      },
      getAttackTags: function (attackUuid) {
        return $http.get(
          UserService.buildAPIUrl('/tags/attack/list/' + attackUuid)
        )
      },
      deleteAttackTags: function (attackUuid, tag) {
        var form = { tag: tag }
        return $http.delete(
          UserService.buildAPIUrl('/tags/attack/' + attackUuid),
          {
            data: form,
            headers: { 'Content-Type': 'application/json' }
          }
        )
      },
      tagAttackEvents: function (attackEventTags) {
        return $http.put(
          UserService.buildAPIUrl('/tags/attack/events'),
          attackEventTags
        )
      },
      tagAttackEventsBulk: function (attackEventTags) {
        return $http.put(
          UserService.buildAPIUrl('/tags/attack/events/bulk'),
          attackEventTags
        )
      },
      getAttackEventsTagsBulk: function (attackEventsUuid) {
        return $http.post(UserService.buildAPIUrl('/tags/attack/events/bulk'), {
          attack_events_uuid: attackEventsUuid
        })
      },
      getAttackEventsTags: function () {
        return $http.get(UserService.buildAPIUrl('/tags/attack/events/list'))
      },
      getAttackEventTags: function (eventUuid) {
        return $http.get(
          UserService.buildAPIUrl('/tags/attack/event/list/' + eventUuid)
        )
      },
      deleteAttackEventTags: function (eventUuid, tag) {
        var form = { tag: tag }
        return $http.delete(
          UserService.buildAPIUrl('/tags/attack/event/' + eventUuid),
          {
            data: form,
            headers: { 'Content-Type': 'application/json' }
          }
        )
      }
    }
  }
})()
